import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalHeaderService } from '../global-header.service';
import { ContextService } from '../context.service';
import { ContentOverview } from '../content-overview';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-content-overview',
  templateUrl: './content-overview.component.html',
  styleUrls: ['./content-overview.component.css']
})
export class ContentOverviewComponent implements OnInit, OnDestroy {
  
  private subscriptions = new Subscription();

  public model : ContentOverview

  constructor(
    private route: ActivatedRoute,
    private contextService: ContextService,
    private headerService: GlobalHeaderService ) {
  }

  ngOnInit() {
    this.model = new ContentOverview();

    var subscription = this.route.paramMap.subscribe(params => {

      var itemsSubscription = this.contextService.getContents().subscribe(data => {
        this.model.items = data;
        this.headerService.setHead(this.model);
      });

      this.subscriptions.add(itemsSubscription);
    });

    this.subscriptions.add(subscription);
  }
  
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
